module.exports = __webpack_public_path__ + "img/textarea.1684b798.svg";